const DEFAULT_ADMIN_ALLOWED_EMAILS = [
  "janne@edustajanne.fi",
  "juhani@kilometrit.fi",
];

function normalizeEmail(value: string | null | undefined) {
  return String(value ?? "").trim().toLowerCase();
}

function parseEmailList(value: string | null | undefined) {
  const seen = new Set<string>();
  for (const item of String(value ?? "").split(",")) {
    const email = normalizeEmail(item);
    if (email) seen.add(email);
  }
  return Array.from(seen);
}

const configuredAdmins = parseEmailList(import.meta.env.VITE_ADMIN_ALLOWED_EMAILS);
export const ADMIN_ALLOWED_EMAILS = configuredAdmins.length > 0
  ? configuredAdmins
  : DEFAULT_ADMIN_ALLOWED_EMAILS;

const configuredPartnerAdmins = parseEmailList(import.meta.env.VITE_PARTNER_ADMIN_ALLOWED_EMAILS);
export const PARTNER_ADMIN_ALLOWED_EMAILS = configuredPartnerAdmins.length > 0
  ? configuredPartnerAdmins
  : ADMIN_ALLOWED_EMAILS;

export function isAdminEmail(email: string | null | undefined) {
  return ADMIN_ALLOWED_EMAILS.includes(normalizeEmail(email));
}

export function isPartnerAdminEmail(email: string | null | undefined) {
  return PARTNER_ADMIN_ALLOWED_EMAILS.includes(normalizeEmail(email));
}
